import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.string.fixed.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Event, EventUtil } from "./lib/utils";
import TableCell from './TableCell';
import ExpandIcon from './ExpandIcon';
import { prefix } from "../../wui-core/src/index.js";
var propTypes = {
  onDestroy: PropTypes.func,
  onRowClick: PropTypes.func,
  onRowDoubleClick: PropTypes.func,
  record: PropTypes.object,
  clsPrefix: PropTypes.string,
  expandIconColumnIndex: PropTypes.number,
  onHover: PropTypes.func,
  columns: PropTypes.array,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  visible: PropTypes.bool,
  index: PropTypes.number,
  hoverKey: PropTypes.any,
  expanded: PropTypes.bool,
  expandable: PropTypes.any,
  onExpand: PropTypes.func,
  needIndentSpaced: PropTypes.bool,
  className: PropTypes.string,
  indent: PropTypes.number,
  indentSize: PropTypes.number,
  expandIconAsCell: PropTypes.bool,
  expandRowByClick: PropTypes.bool,
  store: PropTypes.object.isRequired,
  rowDraggAble: PropTypes.bool,
  onDragRow: PropTypes.func,
  onDragRowStart: PropTypes.func,
  syncRowHeight: PropTypes.bool
};
var defaultProps = {
  onRowClick: function onRowClick() {},
  // onRowDoubleClick() {},
  onDestroy: function onDestroy() {},
  expandIconColumnIndex: 0,
  expandRowByClick: false,
  onHover: function onHover() {},
  className: '',
  setRowParentIndex: function setRowParentIndex() {},
  rowDraggAble: false,
  // onDragRow:()=>{}
  syncRowHeight: false
};

var TableRow = /*#__PURE__*/function (_Component) {
  _inherits(TableRow, _Component);

  var _super = _createSuper(TableRow);

  function TableRow(props) {
    var _this;

    _classCallCheck(this, TableRow);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "initEvent", function () {
      var events = [{
        key: 'touchstart',
        fun: _this.onTouchStart
      }, //手指触摸到一个 DOM 元素时触发
      {
        key: 'touchmove',
        fun: _this.onTouchMove
      }, //手指在一个 DOM 元素上滑动时触发
      {
        key: 'touchend',
        fun: _this.onTouchEnd
      }, //手指从一个 DOM 元素上移开时触发
      {
        key: 'dragstart',
        fun: _this.onDragStart
      }, //用户开始拖动元素时触发
      {
        key: 'dragover',
        fun: _this.onDragOver
      }, //当某被拖动的对象在另一对象容器范围内拖动时触发此事件
      {
        key: 'drop',
        fun: _this.onDrop
      }, //在一个拖动过程中，释放鼠标键时触发此事件
      {
        key: 'dragenter',
        fun: _this.onDragEnter
      }, {
        key: 'dragleave',
        fun: _this.onDragLeave
      }];

      _this.eventListen(events, '', _this.element);
    });

    _defineProperty(_assertThisInitialized(_this), "removeDragAbleEvent", function () {
      var events = [{
        key: 'touchstart',
        fun: _this.onTouchStart
      }, //手指触摸到一个 DOM 元素时触发
      {
        key: 'touchmove',
        fun: _this.onTouchMove
      }, //手指在一个 DOM 元素上滑动时触发
      {
        key: 'touchend',
        fun: _this.onTouchEnd
      }, //手指从一个 DOM 元素上移开时触发
      {
        key: 'dragstart',
        fun: _this.onDragStart
      }, //用户开始拖动元素时触发
      {
        key: 'dragover',
        fun: _this.onDragOver
      }, //当某被拖动的对象在另一对象容器范围内拖动时触发此事件
      {
        key: 'drop',
        fun: _this.onDrop
      }, //在一个拖动过程中，释放鼠标键时触发此事件
      {
        key: 'dragenter',
        fun: _this.onDragEnter
      }, {
        key: 'dragleave',
        fun: _this.onDragLeave
      }];

      _this.eventListen(events, 'remove', _this.element);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e) {
      var onDragRowStart = _this.props.onDragRowStart;
      if (!_this.props.rowDraggAble || _this.notRowDrag) return;
      var event = Event.getEvent(e),
          target = Event.getTarget(event);

      if (target.tagName === 'TD') {
        target = target.parentNode;
      }

      _this.currentIndex = target.getAttribute("data-row-key"); // 拖拽其实index

      _this.props.contentTable.startI = target.getAttribute("data-row-index");
      _this._dragCurrent = target;
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("Text", _this.currentIndex);
      onDragRowStart && onDragRowStart(_this.currentIndex);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragOver", function (e) {
      var event = Event.getEvent(e);
      event.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_this), "onDrop", function (e) {
      var _this$props = _this.props,
          onDragRow = _this$props.onDragRow,
          contentTable = _this$props.contentTable;

      var event = Event.getEvent(e),
          _target = Event.getTarget(event),
          target = _target.parentNode;

      event.preventDefault();
      event.stopPropagation();
      var currentKey = event.dataTransfer.getData("text");
      var targetKey = target.getAttribute("data-row-key");
      if (!targetKey || targetKey === currentKey) return;

      if (target.nodeName.toUpperCase() === "TR") {
        _this.synchronizeTableTr(currentKey, null);

        _this.synchronizeTableTr(targetKey, null);
      }

      onDragRow && onDragRow(currentKey, targetKey);
    });

    _defineProperty(_assertThisInitialized(_this), "getTouchDom", function (event) {
      var currentLocation = event.changedTouches[0];
      var realTarget = document.elementFromPoint(currentLocation.clientX, currentLocation.clientY);
      return realTarget;
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchStart", function (e) {
      e.stopPropagation();
      var onDragRowStart = _this.props.onDragRowStart;

      var event = Event.getEvent(e),
          _target = Event.getTarget(event),
          target = _target.parentNode;

      if (target.tagName === 'TR') {
        _this.currentIndex = target.getAttribute("data-row-key");
        onDragRowStart && onDragRowStart(_this.currentIndex);
      } else {
        _this.canBeTouch = false;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchMove", function (e) {
      if (!_this.canBeTouch) return;
      e.stopPropagation();
      var event = Event.getEvent(e);
      event.preventDefault();

      var touchTarget = _this.getTouchDom(event),
          target = touchTarget.parentNode,
          targetKey = target.getAttribute("data-row-key");

      if (!targetKey || targetKey === _this.currentIndex) return;

      if (target.nodeName.toUpperCase() === "TR") {
        if (_this.cacheCurrentIndex !== targetKey) {
          //模拟 touchenter toucheleave 事件
          _this.cacheCurrentIndex && _this.synchronizeTableTr(_this.cacheCurrentIndex, null); //去掉虚线

          _this.synchronizeTableTr(targetKey, true); //添加虚线

        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onTouchEnd", function (e) {
      if (!_this.canBeTouch) {
        _this.canBeTouch = true;
        return;
      }

      e.stopPropagation();
      var onDragRow = _this.props.onDragRow;

      var event = Event.getEvent(e),
          currentKey = _this.currentIndex,
          //拖拽行的key
      touchTarget = _this.getTouchDom(event),
          //当前触摸的DOM节点
      target = touchTarget.parentNode,
          //目标位置的行
      targetKey = target.getAttribute("data-row-key"); //目标位置的行key


      if (!targetKey || targetKey === currentKey) return;

      if (target.nodeName.toUpperCase() === "TR") {
        _this.synchronizeTableTr(currentKey, null);

        _this.synchronizeTableTr(targetKey, null);
      }

      onDragRow && onDragRow(currentKey, targetKey);
    });

    _defineProperty(_assertThisInitialized(_this), "synchronizeTableTrShadow", function () {
      var _this$props2 = _this.props,
          contentTable = _this$props2.contentTable,
          index = _this$props2.index;
      var cont = contentTable.querySelector(".".concat(prefix, "-table-scroll table tbody")).getElementsByTagName("tr")[index],
          trs = cont.getBoundingClientRect(),
          fixed_left_trs = contentTable.querySelector(".".concat(prefix, "-table-fixed-left table tbody")),
          fixed_right_trs = contentTable.querySelector(".".concat(prefix, "-table-fixed-right table tbody"));
      fixed_left_trs = fixed_left_trs && fixed_left_trs.getElementsByTagName("tr")[index].getBoundingClientRect();
      fixed_right_trs = fixed_right_trs && fixed_right_trs.getElementsByTagName("tr")[index].getBoundingClientRect();
      var div = document.createElement("div");
      var style = "wdith:" + (trs.width + (fixed_left_trs ? fixed_left_trs.width : 0) + (fixed_right_trs ? fixed_right_trs.width : 0)) + "px";
      style += ";height:" + trs.height + "px";
      style += ";classname:" + cont.className;
      div.setAttribute("style", style);
      return div;
    });

    _defineProperty(_assertThisInitialized(_this), "synchronizeTableTr", function (currentIndex, type) {
      if (type) {
        //同步 this.cacheCurrentIndex
        _this.cacheCurrentIndex = currentIndex;
      }

      var contentTable = _this.props.contentTable;

      var _table_trs = contentTable.querySelector(".".concat(prefix, "-table-scroll table tbody")),
          _table_fixed_left_trs = contentTable.querySelector(".".concat(prefix, "-table-fixed-left table tbody")),
          _table_fixed_right_trs = contentTable.querySelector(".".concat(prefix, "-table-fixed-right table tbody"));

      _table_trs = _table_trs ? _table_trs : contentTable.querySelector(".".concat(prefix, "-table table tbody"));

      _this.synchronizeTrStyle(_table_trs, currentIndex, type);

      if (_table_fixed_left_trs) {
        _this.synchronizeTrStyle(_table_fixed_left_trs, currentIndex, type);
      }

      if (_table_fixed_right_trs) {
        _this.synchronizeTrStyle(_table_fixed_right_trs, currentIndex, type);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "synchronizeTrStyle", function (_elementBody, id, type) {
      var contentTable = _this.props.contentTable,
          trs = _elementBody.getElementsByTagName("tr"),
          currentObj;

      for (var index = 0; index < trs.length; index++) {
        var element = trs[index];

        if (element.getAttribute("data-row-key") == id) {
          currentObj = element;
        }
      }

      if (type == 'down') {
        currentObj && currentObj.setAttribute("style", "border-bottom:2px solid #02B1FD");
      } else if (type) {
        currentObj && currentObj.setAttribute("style", "border-top:2px solid #02B1FD");
      } else {
        currentObj && currentObj.setAttribute("style", "");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDragEnter", function (e) {
      var contentTable = _this.props.contentTable;

      var event = Event.getEvent(e),
          _target = Event.getTarget(event),
          target = _target.parentNode;

      var currentIndex = target.getAttribute("data-row-key");
      var dragEnterIndex = target.getAttribute("data-row-index");
      if (!currentIndex || currentIndex === _this.currentIndex) return;
      var dragType = parseInt(dragEnterIndex) > parseInt(contentTable.startI) ? 'down' : 'top';
      contentTable.dragType = dragType;

      if (target.nodeName.toUpperCase() === "TR") {
        _this.synchronizeTableTr(currentIndex, dragType);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDragLeave", function (e) {
      var event = Event.getEvent(e),
          _target = Event.getTarget(event),
          target = _target.parentNode;

      var currentIndex = target.getAttribute("data-row-key");
      if (!currentIndex || currentIndex === _this.currentIndex) return;

      if (target.nodeName.toUpperCase() === "TR") {
        _this.synchronizeTableTr(currentIndex, null);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "stopRowDrag", function (isStop) {
      var rowDraggAble = _this.props.rowDraggAble;
      var notRowDrag = _this.state.notRowDrag;

      if (rowDraggAble && isStop !== notRowDrag) {
        _this.setState({
          notRowDrag: isStop
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "set", function (fn) {
      _this.clear();

      _this._timeout = window.setTimeout(fn, 300);
    });

    _defineProperty(_assertThisInitialized(_this), "clear", function (event) {
      if (_this._timeout) {
        window.clearTimeout(_this._timeout);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "bindElement", function (el) {
      _this.element = el;
    });

    _this._timeout = null;
    _this.state = {
      hovered: false
    };
    _this.onRowClick = _this.onRowClick.bind(_assertThisInitialized(_this));
    _this.onRowDoubleClick = _this.onRowDoubleClick.bind(_assertThisInitialized(_this));
    _this.onMouseEnter = _this.onMouseEnter.bind(_assertThisInitialized(_this));
    _this.onMouseLeave = _this.onMouseLeave.bind(_assertThisInitialized(_this));
    _this.expandHeight = 0;
    _this.event = false;
    _this.cacheCurrentIndex = null;
    _this.canBeTouch = true; //受否允许拖动该行

    return _this;
  }

  _createClass(TableRow, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props3 = this.props,
          store = _this$props3.store,
          hoverKey = _this$props3.hoverKey,
          treeType = _this$props3.treeType,
          rowDraggAble = _this$props3.rowDraggAble;
      this.unsubscribe = store.subscribe(function () {
        if (store.getState().currentHoverKey === hoverKey) {
          _this2.setState({
            hovered: true
          });
        } else if (_this2.state.hovered === true) {
          _this2.setState({
            hovered: false
          });
        }
      });
      this.setRowHeight();

      if (treeType) {
        this.setRowParentIndex();
      }
    }
    /**
     * 事件初始化
     */

  }, {
    key: "eventListen",
    value:
    /**
     * 事件绑定和移除函数
     */
    function eventListen(events, type, eventSource) {
      for (var i = 0; i < events.length; i++) {
        var _event = events[i];

        if (type === "remove") {
          EventUtil.removeHandler(eventSource, _event.key, _event.fun);
        } else {
          EventUtil.addHandler(eventSource, _event.key, _event.fun);
        }
      }
    }
    /**
     * 开始调整交换列的事件
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props4 = this.props,
          rowDraggAble = _this$props4.rowDraggAble,
          syncRowHeight = _this$props4.syncRowHeight;

      if (!this.event) {
        this.event = true;

        if (rowDraggAble) {
          this.initEvent();
        }
      }

      if (this.props.treeType) {
        this.setRowParentIndex();
      } // if(syncRowHeight){
      //   this.setRowHeight()
      // }


      this.setRowHeight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props5 = this.props,
          record = _this$props5.record,
          onDestroy = _this$props5.onDestroy,
          index = _this$props5.index,
          rowDraggAble = _this$props5.rowDraggAble;
      onDestroy(record, index);

      if (this.unsubscribe) {
        this.unsubscribe();
      }

      if (rowDraggAble) {
        this.removeDragAbleEvent();
      }
    }
  }, {
    key: "setRowHeight",
    value: function setRowHeight() {
      var _this$props6 = this.props,
          setRowHeight = _this$props6.setRowHeight,
          _this$props6$expanded = _this$props6.expandedContentHeight,
          expandedContentHeight = _this$props6$expanded === void 0 ? 0 : _this$props6$expanded,
          fixed = _this$props6.fixed,
          fixedIndex = _this$props6.fixedIndex;
      if (!setRowHeight || !this.element || fixed) return;
      setRowHeight(this.element.clientHeight + expandedContentHeight, fixedIndex);
    }
  }, {
    key: "setRowParentIndex",
    value: function setRowParentIndex() {
      var _this$props7 = this.props,
          index = _this$props7.index,
          setRowParentIndex = _this$props7.setRowParentIndex,
          fixedIndex = _this$props7.fixedIndex,
          rootIndex = _this$props7.rootIndex;
      setRowParentIndex(rootIndex < 0 ? index : rootIndex, fixedIndex);
    }
  }, {
    key: "onRowClick",
    value: function onRowClick(event) {
      // fix: 解决 onRowClick 回调函数中，事件对象属性均为 null 的问题
      // 异步访问事件属性
      // 调用 event.persist() 会从事件池中移除该合成函数并允许对该合成事件的引用被保留下来。
      event.persist();
      var _this$props8 = this.props,
          record = _this$props8.record,
          index = _this$props8.index,
          onRowClick = _this$props8.onRowClick,
          expandable = _this$props8.expandable,
          expandRowByClick = _this$props8.expandRowByClick,
          expanded = _this$props8.expanded,
          onExpand = _this$props8.onExpand,
          fixedIndex = _this$props8.fixedIndex,
          onRowDoubleClick = _this$props8.onRowDoubleClick;

      if (expandable && expandRowByClick) {
        onExpand(!expanded, record, fixedIndex, event);
      }

      if (!onRowDoubleClick) {
        onRowClick(record, fixedIndex, event);
        return;
      }

      this.set(function (e) {
        onRowClick(record, fixedIndex, event);
      });
    }
  }, {
    key: "onRowDoubleClick",
    value: function onRowDoubleClick(event) {
      var _this$props9 = this.props,
          record = _this$props9.record,
          index = _this$props9.index,
          onRowDoubleClick = _this$props9.onRowDoubleClick,
          fixedIndex = _this$props9.fixedIndex;
      this.clear();
      onRowDoubleClick && onRowDoubleClick(record, fixedIndex, event);
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter(e) {
      var _this$props10 = this.props,
          onHover = _this$props10.onHover,
          hoverKey = _this$props10.hoverKey,
          fixedIndex = _this$props10.fixedIndex,
          syncHover = _this$props10.syncHover,
          record = _this$props10.record;

      if (syncHover) {
        this.setState({
          hovered: true
        });
      }

      onHover(true, hoverKey, e, fixedIndex, record);
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave(e) {
      var _this$props11 = this.props,
          onHover = _this$props11.onHover,
          hoverKey = _this$props11.hoverKey,
          fixedIndex = _this$props11.fixedIndex,
          syncHover = _this$props11.syncHover,
          record = _this$props11.record;

      if (syncHover) {
        this.setState({
          hovered: false
        });
      }

      onHover(false, hoverKey, e, fixedIndex, record);
    }
  }, {
    key: "render",
    value: // 滚动加载数据时的loading，暂时不用
    // getLoadingStyle = (isPre, isSuf) => {
    //   if (isPre) {
    //     return this.element && this.element.nextSibling ? this.element.nextSibling .getBoundingClientRect() : {}
    //   }
    //   if (isSuf) {
    //     return this.element && this.element.previousSibling ? this.element.previousSibling.getBoundingClientRect() : {}
    //   }
    // }
    function render() {
      var _this$props12 = this.props,
          clsPrefix = _this$props12.clsPrefix,
          columns = _this$props12.columns,
          record = _this$props12.record,
          height = _this$props12.height,
          visible = _this$props12.visible,
          index = _this$props12.index,
          onPaste = _this$props12.onPaste,
          expandIconColumnIndex = _this$props12.expandIconColumnIndex,
          expandIconAsCell = _this$props12.expandIconAsCell,
          expanded = _this$props12.expanded,
          useDragHandle = _this$props12.useDragHandle,
          rowDraggAble = _this$props12.rowDraggAble,
          expandable = _this$props12.expandable,
          onExpand = _this$props12.onExpand,
          needIndentSpaced = _this$props12.needIndentSpaced,
          indent = _this$props12.indent,
          indentSize = _this$props12.indentSize,
          isHiddenExpandIcon = _this$props12.isHiddenExpandIcon,
          fixed = _this$props12.fixed,
          bodyDisplayInRow = _this$props12.bodyDisplayInRow,
          expandedIcon = _this$props12.expandedIcon,
          collapsedIcon = _this$props12.collapsedIcon,
          hoverKey = _this$props12.hoverKey,
          lazyStartIndex = _this$props12.lazyStartIndex,
          lazyEndIndex = _this$props12.lazyEndIndex,
          expandIconCellWidth = _this$props12.expandIconCellWidth,
          getCellClassName = _this$props12.getCellClassName;
      var notRowDrag = this.state.notRowDrag; // const isEmptyTr = isPre || isSuf//暂时不用 滚动loading相关

      var showSum = false;
      var cls = [];

      if (clsPrefix) {
        cls.push(clsPrefix);
      }

      var className = this.props.className;

      if (this.state.hovered) {
        className += " ".concat(clsPrefix, "-hover");
      } //判断是否为合计行


      if (className.indexOf('sumrow') > -1) {
        showSum = true;
      }

      var cells = [];
      var expandIcon = /*#__PURE__*/React.createElement(ExpandIcon, {
        expandable: expandable,
        clsPrefix: clsPrefix,
        onExpand: onExpand,
        needIndentSpaced: needIndentSpaced,
        expanded: expanded,
        record: record,
        expandedIcon: expandedIcon,
        collapsedIcon: collapsedIcon,
        isHiddenExpandIcon: isHiddenExpandIcon
      });
      var isExpandIconAsCell = expandIconAsCell ? "".concat(clsPrefix, "-expand-columns-in-body") : '';
      var expandIndexInThisTable;

      if (this.props.fixed === 'right') {
        expandIndexInThisTable = expandIconColumnIndex - this.props.leftColumnsLength - this.props.centerColumnsLength;
      } else {
        expandIndexInThisTable = expandIconColumnIndex;
      }

      for (var i = 0; i < columns.length; i++) {
        if (expandIconAsCell && i === 0) {
          showSum ? cells.push( /*#__PURE__*/React.createElement("td", {
            width: expandIconCellWidth
          })) : cells.push( /*#__PURE__*/React.createElement("td", {
            className: "".concat(clsPrefix, "-expand-icon-cell ").concat(isExpandIconAsCell),
            key: "rc-table-expand-icon-cell-".concat(i),
            width: expandIconCellWidth
          }, expandIcon));
        } // bugfix 设置expandRowByClick，无法显示箭头，去掉 expandRowByClick 判断


        var isColumnHaveExpandIcon = expandIconAsCell || showSum ? false : i === expandIndexInThisTable; //注意：中间表格区域不需要渲染出固定列的单元格，以节省多余的性能消耗

        if (!fixed && columns[i].fixed) continue;
        cells.push( /*#__PURE__*/React.createElement(TableCell, {
          clsPrefix: clsPrefix,
          record: record,
          indentSize: indentSize,
          indent: indent,
          index: index,
          column: columns[i],
          key: index + "_" + (columns[i].key || columns[i].dataIndex || i),
          fixed: fixed,
          showSum: showSum,
          expandIcon: isColumnHaveExpandIcon ? expandIcon : null,
          bodyDisplayInRow: bodyDisplayInRow,
          lazyStartIndex: lazyStartIndex,
          lazyEndIndex: lazyEndIndex,
          onPaste: onPaste,
          stopRowDrag: this.stopRowDrag,
          col: i,
          getCellClassName: getCellClassName
        }));
      }

      var style = _objectSpread({
        height: height
      }, record ? record.style : undefined);

      if (!visible) {
        style.display = 'none';
      }

      if (record && record._checked) {
        className += ' selected';
      }

      if (rowDraggAble && !useDragHandle && !notRowDrag) {
        className += ' row-dragg-able';
      }

      if (className) {
        cls.push(className);
      }

      if (clsPrefix && indent) {
        cls.push("".concat(clsPrefix, "-level-").concat(indent));
      } // const tdStyle = !isEmptyTr ? {} : this.getLoadingStyle(isPre, isSuf)//暂时不用 滚动loading相关


      return /*#__PURE__*/React.createElement("tr", {
        draggable: rowDraggAble && !useDragHandle && !notRowDrag,
        onClick: this.onRowClick,
        onDoubleClick: this.onRowDoubleClick,
        onMouseEnter: this.onMouseEnter,
        onMouseLeave: this.onMouseLeave,
        className: cls.join(' '),
        style: style,
        "data-for-table": this.props.tableUid,
        "data-row-key": record && record.key ? record.key : hoverKey,
        "data-row-index": this.props.index // key={hoverKey}
        ,
        ref: this.bindElement
      }, cells.length > 0 ? cells : /*#__PURE__*/React.createElement("td", {
        style: {
          width: 0,
          padding: 0
        }
      }));
    }
  }]);

  return TableRow;
}(Component);

_defineProperty(TableRow, "defaultProps", {
  tableUid: null
});

;
TableRow.propTypes = propTypes;
TableRow.defaultProps = defaultProps;
export default TableRow;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/TableRow.js